module.exports = __webpack_public_path__ + "img/دفتر-یادداشت-مقوایی.60e7578b.png";